import {
    DequeuedReason,
    EnqueueAttemptRejectReason,
    ConversationEndedReason,
    WorkItemResult,
} from '@dxp/core/types';

export const activityResultTypeToText = (
    result:
        | WorkItemResult
        | DequeuedReason
        | EnqueueAttemptRejectReason
        | ConversationEndedReason,
): string => {
    return result.replace(/([A-Z])/g, ' $1').trim();
};
